if (window.__autoGiftInit) { console.warn('[AutoGift] bereits initialisiert'); }
else {
window.__autoGiftInit = true;

const AutoGift = {
  TRIGGER_COLLECTION: 'accessoires',
  GIFT_VARIANT_ID: 39816622178378,

  triggerVariantIds: [],
  _syncing: false,
  _syncTimer: null,

  async fetchCollectionVariantIds() {
    try {
      const res = await fetch(
        `/collections/${this.TRIGGER_COLLECTION}/products.json?limit=250`
      );
      const data = await res.json();
      this.triggerVariantIds = data.products.flatMap(
        p => p.variants.map(v => v.id)
      );
    } catch (e) {
      console.error('[AutoGift] Collection konnte nicht geladen werden:', e);
    }
  },

  async getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  // KERN-FIX: /cart/update.js SETZT absolute Menge (idempotent, kein Doppel-Add)
  async setGiftQty(quantity) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [this.GIFT_VARIANT_ID]: quantity } })
    });
  },

  async refreshCartDrawer() {
    try {
      const resp = await fetch('/?sections=cart-drawer');
      const data = await resp.json();
      if (!data['cart-drawer']) return;

      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');

      const newItems = html.querySelector('.cart-drawer__line-items');
      const curItems = document.querySelector('.cart-drawer__line-items');
      if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

      const newCount = html.querySelector('cart-count');
      document.querySelectorAll('cart-count').forEach(el => {
        if (newCount) el.textContent = newCount.textContent;
      });
    } catch (e) {
      console.error('[AutoGift] Cart Drawer refresh fehlgeschlagen:', e);
    }
  },

  async sync() {
    if (this._syncing || this.triggerVariantIds.length === 0) return;
    this._syncing = true;

    try {
      const cart = await this.getCart();

      // Gesamtmenge aller Accessoires-Produkte
      const triggerQty = cart.items
        .filter(i => this.triggerVariantIds.includes(i.variant_id))
        .reduce((sum, i) => sum + i.quantity, 0);

      // Aktuelle Geschenk-Menge (ueber alle Line-Items summiert)
      const currentGiftQty = cart.items
        .filter(i => i.variant_id === this.GIFT_VARIANT_ID)
        .reduce((sum, i) => sum + i.quantity, 0);

      // Nur aendern wenn noetig
      if (triggerQty !== currentGiftQty) {
        await this.setGiftQty(triggerQty);
        await this.refreshCartDrawer();
      }
    } finally {
      this._syncing = false;
    }

    setTimeout(() => this.hideRemoveButton(), 150);
  },

  hideRemoveButton() {
    document
      .querySelectorAll(
        `[data-variant-id="${this.GIFT_VARIANT_ID}"],
         [data-product-variant-id="${this.GIFT_VARIANT_ID}"]`
      )
      .forEach(el => {
        const row = el.closest(
          'tr, .cart-item, [class*="cart__item"], [class*="cart-item"]'
        );
        if (!row) return;
        row.querySelectorAll(
          '.cart__remove, [class*="remove"], a[href*="change"], ' +
          'button[aria-label*="Remove"], button[aria-label*="Entfernen"]'
        ).forEach(btn => (btn.style.display = 'none'));
      });
  },

  scheduleSync() {
    clearTimeout(this._syncTimer);
    this._syncTimer = setTimeout(() => this.sync(), 350);
  },

  patchFetch() {
    const self = this;
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const result = await originalFetch(...args);
      if (self._syncing) return result;
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url ?? '');
      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update')
      ) {
        self.scheduleSync();
      }
      return result;
    };
  },

  async init() {
    // B2B-Kunden komplett ausschließen (Tag wird via Liquid in theme.liquid gesetzt)
    if (window.__isB2B) return;

    await this.fetchCollectionVariantIds();
    await this.sync();

    document.addEventListener('cart:updated', () => this.scheduleSync());
    document.addEventListener('cart:refresh', () => this.scheduleSync());
    document.addEventListener('cart:change',  () => this.scheduleSync());

    this.patchFetch();
  }
};

document.addEventListener('DOMContentLoaded', () => AutoGift.init());
} // end guard
